<template>
  <div class="thousand_layout">
    <!-- 退税历史列表 -->
    <div class="taxHistoryBox" v-if="!isNewTax">
      <div class="taxGoBack">
        <el-button type="primary" @click="isNewTax=!isNewTax">{{$t('base.AddRefundRequirement')}}</el-button>
      </div>
      <ul class="taxHistoryList">
        <li class="historyTop">
          <div>{{$t('base.applicationtime')}}</div>
          <div>{{$t('base.taxrefundamount')}}</div>
          <div>{{$t('base.orderquantity')}}</div>
          <div>{{$t('base.status')}}</div>
          <div>{{$t('base.operate')}}</div>
        </li>
        <li v-for="(item,index) in taxList" :key="index" v-if="taxList">
          <div>{{setTime(item.CreateDate)}}</div>
          <div>{{item.RealDrawBackAmountUnit}} {{item.ForecastDrawBackAmount.toFixed(2)}}</div>
          <div>{{item.OrderListCount}}</div>
          <div>
            <span class="state have" v-if="item.RefundTaxState==1">{{$t('base.processing')}}</span>
            <span class="state pass" v-if="item.RefundTaxState==2">{{$t('base.taxrefunded')}}</span>
            <span class="state reject" v-if="item.RefundTaxState==3||item.RefundTaxState==4">{{$t('base.rejected')}}</span>
          </div>
          <div><span class="view" @click="goto(item,'taxDetails')">{{$t('base.viewDetails')}}</span></div>
        </li>
      </ul>

      <list-pagination class="pagination" :TotalCount="TotalCount" :ps="ps" @ps='pageSize' @pi='pageIndex' v-if="!resultTpye"/>
      <n-o-t-n class="notfind" title="" :text="$t('base.noData')" v-if="resultTpye"/>
      <view-details title="Application Detail" :list="taxOrder" dialogClass="taxBox" :domVisible='dislogType.taxDetails' v-if='dislogType.taxDetails' @closeDialog="closeDialog" />
    </div>
    <!-- 申请退税 -->
    <div class="" v-if="isNewTax">
      <div class="taxGoBack">
        <el-button type="" class="base" @click="isNewTaxAndisSubmit">{{$t('base.back')}}</el-button>
        <el-button type="primary" class="submit" :disabled="disabled" @click="addOrderRefundTax">{{$t('base.Submit')}}</el-button>
        <div class="hint">
          <div class="hintBox">
            <div class="title">{{$t('base.hint')}}</div>
            <ul>
              <li>{{$t('alert.onceAweek')}}</li>
              <li>{{$t('alert.beProcessedWith')}}</li>
            </ul>
          </div>
        </div>
      </div>
      <div>
        <new-tax ref="newTax" @isSubmit="isSubmit" :userInfo='userInfo' />
      </div>
    </div>
  </div>
</template>
<script>
import { getTime } from "@/api/public";
import ListPagination from '@/components/listpagination'
import ViewDetails from "@/components/dialog/taxDetails";
import NewTax from '@/pages/user/newtax'
import NOTN from "@/components/notnull.vue";
export default {
  name: 'tax',
  components: { ListPagination, ViewDetails, NewTax ,NOTN},
  data() {
    return {
      resultTpye:false,
      taxList: null,
      taxOrder:null,
      isNewTax: false, // 是否发起退税
      pi: 1,
      ps: 60,
      TotalCount: 0,
      ifData: true,
      picListLimit: 1,
      dislogType: this.$enumInfo.dislogType,
      disabled: true
    }
  },
  props: {
    userInfo: {}
  },
  created() {
    this.getALert()
    this.getTaxList()
  },
  mounted() {},
  methods: {

    setTime(val) {
      return getTime(val, -8, '', 'cn')
    },
    goto(obj, val) {
      if(val=='taxDetails'){
        this.taxOrder=obj
      }
      this.closeDialog(val, true)
    },
    //
    closeDialog(val, bol) {
      this.dislogType[val] = bol;
    },
    //
    getALert(){
      this.$alert(this.$t('alert.taxRefundAlert'), this.$t('title.noticeAboutTaxRefund'), {
          confirmButtonText: this.$t('base.done'),
          callback: action => {
          }
        });
    },
    // 获取退税历史列表
    /**
     * 获取退税订单列表数据
     * @description 通过会员ID分页获取退税订单信息,处理订单数据并更新列表状态
     * @returns {Promise} 返回请求Promise对象
     * @throws {Error} 请求失败时抛出错误
     * @private
     */
    getTaxList() {
      let that = this
      let data = { MemberId: that.userInfo.MappingUserId, PageIndex: that.pi, PageSize: that.ps}
      that.$get(this.$interface.GetOrderRefundTaxPage, data).then(res => {
        if (res.Result != 0) {
          if(res.Count<=0){
            that.resultTpye=true
            return 
          }
          that.TotalCount=res.Count
          var data=res.Data
          data.map(item=>{
            // item.Remarks=''
            // item.OrderList.map(it=>{
            //   if(it.Remarks){
            //     item.Remarks+=(it.Remarks+" ")
            //   }
            // })
            item.OrderListCount=item.OrderList.length
          })
          //console.log(data,data[0],'data')
          that.taxList=data
        }else {
          that.resultTpye=true
        }
      }).catch(err=>{
        that.resultTpye=true
      })

    },
    // 退税申请
    /**
     * 添加退税订单信息
     * 通过接口提交新的退税订单数据,成功后刷新列表
     * @method addOrderRefundTax
     * @returns {void}
     * @description
     * - 获取退税表单数据
     * - 调用AddOrderRefundTax接口提交数据
     * - 成功时显示成功提示,关闭表单,刷新列表
     * - 失败时显示错误提示
     */
    addOrderRefundTax() {
      let that = this
      let data = that.$refs.newTax.taxDetail
      that.$post(that.$interface.AddOrderRefundTax, data).then(res => {
        if (res.Result != 0) {
          that.isNewTax=!that.isNewTax
           that.$message({
            type: 'success',
            // message: res.msg
            message: res.Msg
          }); 
          that.isSubmit(true)
          that.getTaxList()
        } else {
          that.$message({
            type: 'error',
            // message: res.msg
            message: res.Msg
          });
        }
      })
    },
    isNewTaxAndisSubmit(){
      this.disabled = true
      this.isNewTax=!this.isNewTax
    },
    isSubmit(val) {
      this.disabled = val
    },
    // 每页几条
    pageSize(val) {
      this.ps = val
      this.getTaxList();

    },
    // 页码
    pageIndex(val) {
      this.pi = val
      this.getTaxList();
    },
  }
}

</script>
<style scoped>
.taxGoBack {
  margin: 20px 0;
  display: flex;
  align-items: center;
}

.taxGoBack .base {
  color: #5F6DAE;
  border-color: #5F6DAE;
}

/deep/.taxGoBack .el-button span {
  display: flex;
  align-items: center;
}

/deep/.taxGoBack .el-button span:before {
  content: '';
  display: inline-block;
  margin-right: 5px;
  width: 13px;
  height: 13px;
  background: url(../../../static/images/btn_add.png) no-repeat;
  background-size: contain;
}

/deep/.taxGoBack .base span:before {
  background-image: url(../../../static/images/btn_arrow_left.png);
}

/deep/.taxGoBack .submit span:before {
  width: 0px;
  height: 0px;
  margin: 0;
}

.thousand_layout {
  width: 960px;
}

.taxHistoryList {}

.taxHistoryList>li {
  display: flex;
  border-bottom: 1px solid #e0e0e0;
}

.taxHistoryList>li>div {
  width: 20%;
  box-sizing: border-box;
  padding: 14px 12px;
}

.taxHistoryList .historyTop {
  background-color: #f7f7f7;
}

.taxHistoryList .historyTop>div {
  padding: 16px 12px;
  color: #333;
}

.taxHistoryList .state {
  display: flex;
  align-items: center;
}

.taxHistoryList .state:before {
  content: '●';
  margin-right: 5px;
}

.taxHistoryList .state.pass {
  color: #58A800;
}

.taxHistoryList .state.reject {
  color: #E02020;
}

.taxHistoryList .state.have {
  color: #F0AD4E;
}

.view {
  cursor: pointer;
}

.view:hover {
  color: #5F6DAE;
  text-decoration: underline;
}

.hint {
  width: 16px;
  height: 16px;
  background: url(../../../static/images/icon/icon_hint.svg) center no-repeat;
  background-size: contain;
  margin-left: 8px;
  cursor: pointer;
  position: relative;
}

.hintBox {
  display: none;
  position: absolute;
  width: 256px;
  padding: 8px 12px;
  border-radius: 4px;
  background-color: #fff;
  left: -119px;
  top: -145px;
  line-height: 1.5;
  box-shadow: 2px 2px 17px 0px rgba(0, 0, 0, 0.10);
  z-index: 9;
}

.hint:hover .hintBox {
  display: block;
}

.hintBox:before {
  content: '';
  width: 12px;
  height: 12px;
  background-color: #fff;
  transform: rotate(45deg);
  position: absolute;
  bottom: -2px;
  left: 47%;
}

.hintBox .title {
  font-size: 16px;
  font-weight: 700;
}

.hintBox li {
  list-style: decimal;
  margin-left: 14px;
}

</style>



// WEBPACK FOOTER //
// src/pages/user/taxrefund.vue